import "./CompleteAssessmentModal.css";

import { Dispatch, SetStateAction } from "react";

import { Button, Column, Modal, Row } from "../../../../widget";
import { useCompleteAssessmentModal } from "./useCompleteAssessmentModal";

interface CompleteAssessmentModalProps {
  show: boolean;
  onClose: () => void;
  activityUuid: string;
  activityStatus: string;
  activityRowVersion: number;
  activityAssessmentUuid: string;
  activityAssessmentStatus: string;
  activityAssessmentRowVersion: number;
  refreshActivityReviews?: boolean;
  setRefreshActivityReviews?: Dispatch<SetStateAction<boolean>>;
  exitActivityReviewWizard?: () => void;
}

export const CompleteAssessmentModal = ({
  show,
  onClose,
  activityUuid,
  activityStatus,
  activityRowVersion,
  activityAssessmentUuid,
  activityAssessmentStatus,
  activityAssessmentRowVersion,
  refreshActivityReviews,
  setRefreshActivityReviews,
  exitActivityReviewWizard,
}: CompleteAssessmentModalProps): JSX.Element => {
  const { isLoading, onConfirmClick } = useCompleteAssessmentModal({
    activityUuid,
    activityStatus,
    activityRowVersion,
    onClose,
    activityAssessmentUuid,
    activityAssessmentStatus,
    activityAssessmentRowVersion,
    refreshActivityReviews,
    setRefreshActivityReviews,
    exitActivityReviewWizard,
  });

  return (
    <Modal show={show} title="Complete assessment" onClose={onClose}>
      <Row spacingV="ll" justify="center">
        <Column span={10}>
          <span className="body1">
            The assessment, including all internal comments, will be passed to the second reviewer. Once sent, you will
            no longer be able to edit your review responses.
          </span>
        </Column>
      </Row>
      <Row justify="center">
        <Column span={6}>
          <div className="CompleteAssessmentModalButtons">
            <Button text="Complete assessment" onClick={onConfirmClick} isLoading={isLoading} />
            <Button variant="secondary" text="Cancel" onClick={onClose} />
          </div>
        </Column>
      </Row>
    </Modal>
  );
};
